module.exports = __webpack_public_path__ + "img/content-img2_3.62a0d8d7.png";